(() => {
  'use strict';
  let config = {};
  try { config = JSON.parse(document.getElementById('ns-config').textContent); } catch { config = {}; }
  const money = value => { try { return new Intl.NumberFormat('sr-Latn-ME', {style: 'currency', currency: config.currency || 'EUR'}).format(Number(value || 0) / 100); } catch { return (Number(value || 0) / 100).toFixed(2).replace('.', ',') + ' €'; } };

  /* Korpa: cijena dostave i ukupno sa dostavom (osvježava se sa svakom promjenom korpe) */
  function updateShipping(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;
    const threshold = Number(config.threshold || 0);
    const cost = Number(config.shippingCost || 0);
    const free = threshold > 0 && cart.total_price >= threshold;
    const shipping = free ? 0 : cost;
    document.querySelectorAll('[data-ns-shipping-cost]').forEach(el => { el.textContent = free ? 'Dostava: besplatna' : 'Dostava: ' + money(shipping); });
    document.querySelectorAll('[data-ns-cod-total]').forEach(el => { el.textContent = 'Ukupno sa dostavom: ' + money(cart.total_price + shipping); });
  }
  document.addEventListener('cart:updated', event => updateShipping(event.detail && event.detail.cart));

  /* Mobilna traka za kupovinu: vidljiva i dok je glavno dugme ispod ekrana */
  function stickyBelow() {
    const product = document.querySelector('[data-ns-product]');
    if (!product || !window.IntersectionObserver) return;
    const buy = product.querySelector('#ns-buy-row');
    const sticky = product.querySelector('.mobile-buy');
    if (!buy || !sticky || sticky.dataset.nsBelow) return;
    sticky.dataset.nsBelow = 'true';
    new IntersectionObserver(entries => {
      entries.forEach(entry => sticky.classList.toggle('ns-below', !entry.isIntersecting && entry.boundingClientRect.top > 0));
    }, {threshold: 0}).observe(buy);
  }
  stickyBelow();
  document.addEventListener('shopify:section:load', stickyBelow);

  /* Kolačići: kompaktna traka, Shopify Customer Privacy API (isti mehanizam koji koriste aplikacije za saglasnost) */
  function cookieBar() {
    const bar = document.getElementById('ns-cookie');
    if (!bar || bar.dataset.nsBound) return;
    bar.dataset.nsBound = 'true';
    const mode = bar.dataset.mode || 'all';
    let stored = null;
    try { stored = localStorage.getItem('ns-consent'); } catch { stored = null; }
    const setHeight = () => { document.documentElement.style.setProperty('--ns-cookie-h', bar.hidden ? '0px' : bar.offsetHeight + 'px'); document.body.classList.toggle('ns-cookie-open', !bar.hidden); };
    const show = () => { bar.hidden = false; setHeight(); };
    const hide = () => { bar.hidden = true; setHeight(); };
    const decide = () => {
      const api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api) { if (!stored) show(); return; }
      let undecided = !stored;
      try { if (typeof api.getTrackingConsent === 'function') undecided = api.getTrackingConsent() === 'no_interaction'; } catch {}
      if (!undecided) return;
      if (mode === 'regulated' && typeof api.shouldShowBanner === 'function') { try { if (!api.shouldShowBanner()) return; } catch {} }
      show();
    };
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], () => decide());
    } else decide();
    bar.addEventListener('click', event => {
      const button = event.target.closest('[data-ns-consent]');
      if (!button) return;
      const all = button.dataset.nsConsent === 'all';
      const consent = {analytics: all, marketing: all, preferences: all, sale_of_data: all};
      const done = () => { try { localStorage.setItem('ns-consent', all ? 'all' : 'essential'); } catch {} hide(); };
      const api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.setTrackingConsent === 'function') { try { api.setTrackingConsent(consent, done); } catch { done(); } } else done();
    });
    window.addEventListener('resize', () => { if (!bar.hidden) setHeight(); });
  }
  cookieBar();
})();
